var _rect, _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 73,
    viewBox: "0 0 76 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.517883,
    width: 72.6257,
    height: 72.6257,
    rx: 8,
    fill: "#FFF1F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_68_1173)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.8467,
    y: 13.8726,
    width: 20.2256,
    height: 20.2256,
    rx: 10.1128,
    fill: "#FECBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9274 26.5662C51.9274 25.5709 52.0166 24.8551 52.195 24.4186C52.3729 23.9827 52.7507 23.5067 53.3281 22.9906C53.8319 22.5483 54.2158 22.1642 54.4797 21.8383C54.7441 21.513 54.8763 21.1414 54.8763 20.7236C54.8763 20.2199 54.7075 19.8021 54.3699 19.4703C54.0317 19.1386 53.5616 18.9727 52.9595 18.9727C52.3329 18.9727 51.8566 19.1632 51.5308 19.5441C51.2054 19.925 50.9752 20.312 50.84 20.7052L48.9416 19.8942C49.1997 19.1079 49.6727 18.4259 50.3608 17.8484C51.0489 17.2709 51.9151 16.9822 52.9595 16.9822C54.2497 16.9822 55.242 17.3417 55.9365 18.0607C56.6305 18.7793 56.9774 19.6424 56.9774 20.6499C56.9774 21.2643 56.8455 21.7897 56.5816 22.2261C56.3171 22.6621 55.9023 23.1565 55.3371 23.7094C54.735 24.2869 54.3696 24.7261 54.2408 25.0269C54.1116 25.3281 54.047 25.8412 54.047 26.5662H51.9274ZM52.9595 30.9896C52.5541 30.9896 52.2071 30.8453 51.9186 30.5568C51.6296 30.2678 51.4851 29.9206 51.4851 29.5151C51.4851 29.1096 51.6296 28.7624 51.9186 28.4734C52.2071 28.1849 52.5541 28.0407 52.9595 28.0407C53.365 28.0407 53.7122 28.1849 54.0012 28.4734C54.2897 28.7624 54.434 29.1096 54.434 29.5151C54.434 29.9206 54.2897 30.2678 54.0012 30.5568C53.7122 30.8453 53.365 30.9896 52.9595 30.9896Z",
    fill: "#E21E58"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8369,
    cy: 30.795,
    r: 9.14481,
    fill: "#D13764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5892 52.7463V58.7531H51.0846V52.7463C51.0846 51.4414 50.7247 50.2266 50.0048 49.1017C49.2848 47.9768 48.3174 47.0994 47.1026 46.4695C44.4479 45.1646 41.7599 44.1855 39.0386 43.5322C36.3155 42.8807 33.5816 42.5549 30.8369 42.5549C28.0922 42.5549 25.3592 42.8807 22.6379 43.5322C19.9148 44.1855 17.2259 45.1646 14.5712 46.4695C13.3564 47.0994 12.389 47.9768 11.6691 49.1017C10.9491 50.2266 10.5892 51.4414 10.5892 52.7463Z",
    fill: "#FF99B0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_68_1173",
    x: 30.8467,
    y: 13.8726,
    width: 44.2256,
    height: 44.2256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_68_1173"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1173"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_68_1173"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_68_1173",
    result: "effect2_dropShadow_68_1173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_68_1173",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWho);
export default __webpack_public_path__ + "static/media/who.03ed743d4c69ae660f2ca2aeb62b937b.svg";
export { ForwardRef as ReactComponent };